<template>
    <v-row no-gutters>
        <Snackbar v-if="errored" msg="Error from Server" />
        <Snackbar v-if="edited" msg="Operation Successfull" />
        <v-card-title>Edit Resource</v-card-title>
        <v-col cols="12">
        <v-form ref="form" v-model="valid">
            <v-container>
                <v-row>
                    <v-col
                    cols="6"
                    >
                        <v-text-field
                            v-model="title"
                            :rules="titleRules"
                            :loading="loading"
                            label="Title*"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col
                    cols="6"
                    >
                        <v-file-input
                            :rules="imageRules"
                            v-model="image"
                            show-size
                            accept="image/*"
                            label="File input"
                        ></v-file-input>
                    </v-col>
                    <v-col>
                        <v-autocomplete
                        :rules="projectRules"
                        :items="items"
                        :loading="loading"
                        :disabled="loading"
                        item-text="name"
                        label="Select a project"
                        return-object
                        persistent-hint
                        v-model="project"
                        ></v-autocomplete>

                    </v-col>                    
                    <v-col>
                        <v-text-field
                        v-model="url"
                        :loading="loading"
                        label="URL"
                        ></v-text-field>
                    </v-col>
                    <v-col
                    cols="12"
                    >
                    <v-textarea
                        v-model="description"
                        :rules="descriptionRules"
                        :loading="loading"
                        label="Description*"
                        required
                        rows="3"
                    ></v-textarea>
                    </v-col>
                    <v-col cols="12">
                        <v-btn
                            depressed
                            :disabled="loading"
                            :loading="loading"
                            color="primary"
                            class="mr-4"
                            @click="submit"
                            >
                            Submit
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
        </v-col>
    </v-row>
</template>
<script>
import axios from '../../plugins/axios'
import Snackbar from '@/components/Snackbar.vue'
export default {
    name: 'EditResource',
    components: {
        Snackbar
    },
	props: ['editId'],
    data: () => ({
        items: [],
        resource: null,
        valid: false,
        loading: false,
        errored: false,
        edited: false,
        image: null,
        title: '',
        description: '',
        project: null,
        url: [],
        titleRules: [
            v => !!v || 'Full Name is required'
            // v => v.length <= 10 || 'title must be less than 10 characters',
        ],
        descriptionRules: [
            v => !!v || 'Description is required'
        ],
        projectRules: [
            v => !!v || 'Project is required'
            // v => v.length <= 10 || 'title must be less than 10 characters',
        ],        
        urlRules: [
            v => !!v || 'url is required'
            // v => v.length <= 10 || 'title must be less than 10 characters',
        ],
        imageRules: [
            value => !value || value.size < 500000 || 'Image size should be less than 500 KB!',
        ]
    }),

    mounted() {
        this.getResource();
        this.loading = true
        axios
            .get(`/project/`)
            .then(res => {
                this.items = res.data.data
                this.loading = false
            })
            .catch(err => {
                console.error("axios err", err)
                this.errored = true
                this.loading = false
            })        
    },
    methods: {
        getResource(){
            this.loading = true
            axios
            .get(`/resource/byId/` + this.editId)
            .then(res => {
                this.resource = res.data.data
                this.loading = false
                this.title = this.resource.title;
                this.description = this.resource.description;
                this.url = this.resource.url;
                this.project = this.resource.projectId,
                this.image = new File(this.resource.image.data, this.title, {type: 'image/*'});
            })
            .catch(err => {
                console.error("axios err", err)
                this.errored = true
                this.loading = false
            });
        },

        toBase64(file) {
            return new Promise((resolve, reject) => {
                const fr = new FileReader()
                fr.readAsDataURL(file);
                fr.onload = () => resolve(fr.result);
                fr.onerror = error => reject(error);
            })
        },

        async submit () {
            this.errored, this.edited = false
            if(this.$refs.form.validate()){
                this.loading = !this.loading;
                let {title, description, resource, image, url, project} = this;
                let data = {
                    title, 
                    description,
                    projectId: project._id,
                    url
                }
                if(image){
                    let fileToBase64 = await this.toBase64(image)
                    data['image'] = fileToBase64
                }
                axios.put(`/resource/`,
                    {
                        condition: {_id: resource._id},
                        data
                    })
                    .then((res) => {
                        this.resource = res.data.data;
                        this.edited = true;
                    })
                    .catch(err => {
                        console.error("error", err)
                        this.errored = true
                    })
                    .finally(() => {
                        this.loading = false
                    });
            }
        },
		reset () {
			this.$refs.form.reset();
		}
    },
    watch: {
        editId: function() {
			if(this.editId){
				this.getResource();
			}
        }
    }            
}
</script>